import { useZodForm } from '../../../hooks/useZodForm.ts';
import { schCertifyModalForm } from '../schemas.ts';

export const useCertifyModalForm = () =>
  useZodForm({
    schema: schCertifyModalForm,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    defaultValues: {},
  });
